import { createIcon } from '@mote/ui/components/icon'
import { pxTorem } from '@mote/ui/theme/utils'
import { defaultProps } from './defaultProps'

export const QrCodeIcon = createIcon({
  displayName: 'QrCodeIcon',
  path: [
    <g clipPath='url(#clip0)'>
      <path
        d='M0 0V6.30859H6.30859V0H0ZM4.82422 4.82422H1.48438V1.48438H4.82422V4.82422Z'
        fill='currentColor'
      />
      <path
        d='M3.89653 2.41208H2.41216V3.89645H3.89653V2.41208Z'
        fill='currentColor'
      />
      <path
        d='M12.6915 -3.05176e-05V6.30856H19.0001V-3.05176e-05H12.6915ZM17.5157 4.82419H14.1759V1.48434H17.5157V4.82419Z'
        fill='currentColor'
      />
      <path
        d='M16.588 2.41208H15.1036V3.89645H16.588V2.41208Z'
        fill='currentColor'
      />
      <path
        d='M-2.09808e-05 12.6914V19H6.30857V12.6914H-2.09808e-05ZM4.8242 17.5156H1.48435V14.1758H4.8242V17.5156Z'
        fill='currentColor'
      />
      <path
        d='M3.89653 15.1035H2.41216V16.5879H3.89653V15.1035Z'
        fill='currentColor'
      />
      <path
        d='M2.96878 7.31052H1.4844V8.79489H2.96878V7.31052Z'
        fill='currentColor'
      />
      <path
        d='M4.4532 10.2792V8.79486H2.96883V10.2792H4.41609V11.7636H5.90047V10.2792H4.4532Z'
        fill='currentColor'
      />
      <path
        d='M11.8751 2.85742H10.3907V4.3418H11.8751V2.85742Z'
        fill='currentColor'
      />
      <path
        d='M8.90623 1.48434H7.42186V4.34177H8.90623V1.48434Z'
        fill='currentColor'
      />
      <path
        d='M10.3907 -3.05176e-05H8.90628V1.48434H10.3907V-3.05176e-05Z'
        fill='currentColor'
      />
      <path
        d='M8.90624 4.3418V5.82617H7.42186V7.31055H10.3906V4.3418H8.90624Z'
        fill='currentColor'
      />
      <path
        d='M10.3906 13.1738V11.7265H8.90623V8.79486H7.42186V11.7636H8.90623V13.2109H10.3906V14.6581H13.3594V13.1738H10.3906Z'
        fill='currentColor'
      />
      <path
        d='M11.8751 7.31052H10.3907V10.2793H11.8751V7.31052Z'
        fill='currentColor'
      />
      <path
        d='M17.5157 8.75778V7.31052H14.8067V8.79489H13.3594V10.2793H14.8438V11.7265H19.0001V8.75778H17.5157ZM17.5157 10.2422H14.8438V8.79489H17.5157V10.2422Z'
        fill='currentColor'
      />
      <path
        d='M19.0001 13.1738H17.5157V16.1426H19.0001V13.1738Z'
        fill='currentColor'
      />
      <path
        d='M13.3595 10.2793H11.8751V11.7637H13.3595V10.2793Z'
        fill='currentColor'
      />
      <path
        d='M14.8438 14.6582H13.3594V16.1426H14.8438V14.6582Z'
        fill='currentColor'
      />
      <path
        d='M16.3281 13.1738H14.8437V14.6582H16.3281V13.1738Z'
        fill='currentColor'
      />
      <path
        d='M14.8437 16.1425V19H16.3281V17.6269H17.5156V16.1425H14.8437Z'
        fill='currentColor'
      />
      <path
        d='M8.90623 13.2109H7.42186V16.0312H8.90623V13.2109Z'
        fill='currentColor'
      />
      <path
        d='M11.875 17.5156V16.0312H8.90628V19H10.3907V17.5156H11.8379V19H13.3223V17.5156H11.875Z'
        fill='currentColor'
      />
      <path
        d='M7.42198 7.31052H4.45323V8.79489H7.42198V7.31052Z'
        fill='currentColor'
      />
      <path
        d='M1.48435 8.79486H-2.09808e-05V11.7636H1.48435V8.79486Z'
        fill='currentColor'
      />
    </g>,
    <defs>
      <clipPath id='clip0'>
        <rect width='19' height='19' fill='currentColor' />
      </clipPath>
    </defs>
  ],
  viewBox: '0 0 19 19',
  defaultProps: {
    ...defaultProps,
    width: pxTorem(19).valueWithUnit,
    height: pxTorem(19).valueWithUnit
  }
})
